<form [formGroup]="inputForm" class="holder">
  <mat-form-field>
    <mat-label>Vad tror du slutpriset blir?</mat-label>
    <input
      matInput
      formControlName="expectedPrice"
      inputmode="numeric"
      spbFormatNumber>

    <span matTextSuffix>kr</span>
    @if (inputForm.controls.expectedPrice.errors && inputForm.controls.expectedPrice.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }

    <mat-error>
      @if (inputForm.controls.expectedPrice.errors?.max) {
        Värdet får inte överstiga 99 999 999 kr
      } @else {
        Fältet ska fyllas i.
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Kontantinsats</mat-label>
    <input
      matInput
      formControlName="downPayment"
      inputmode="numeric"
      spbFormatNumber>
    <span matTextSuffix>kr</span>
    @if (inputForm.controls.downPayment.errors && inputForm.controls.downPayment.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }
    <mat-error>
      @if (inputForm.controls.downPayment.errors?.minDownPayment) {
        Värdet är för lågt. Kontantinsatsen måste vara minst
        {{ this.hemnetService.currentDownPaymentPercent() | percent:'1.0-0' }}
        ({{ calculatedDownPayment }}) av bostadens pris.
      } @else if (inputForm.controls.downPayment.errors?.max) {
        Värdet är för högt. Det måste vara lägre än bostadens pris.
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Ränta</mat-label>
    <input
      matInput
      formControlName="interestRate"
      type="text">
    <span matTextSuffix>%</span>
    @if (inputForm.controls.interestRate.errors && inputForm.controls.interestRate.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }
    @if (listRate === inputForm.controls.interestRate.value) {
      <mat-hint id="interestRate-hint">Genomsnittsränta senaste månaden för lån
        bundet på 3 månader
      </mat-hint>
    }
    <mat-error>
      @if (inputForm.controls.interestRate.errors) {
        Fältet ska fyllas i.
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Månadsavgift</mat-label>
    <input
      matInput
      formControlName="fee"
      inputmode="numeric"
      spbFormatNumber>
    <span matTextSuffix>kr</span>
    @if (inputForm.controls.fee.errors && inputForm.controls.fee.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }

    <mat-error>Värdet får inte överstiga 99 999 kr.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Driftskostnad per år</mat-label>
    <input
      matInput
      formControlName="runCost"
      inputmode="numeric"
      spbFormatNumber>
    <span matTextSuffix>kr</span>
    @if (inputForm.controls.runCost.errors && inputForm.controls.runCost.touched) {
      <mat-icon matIconSuffix aria-hidden="true">priority_high
      </mat-icon>
    }
    <mat-error>Värdet får inte överstiga 999 999 kr.
    </mat-error>
  </mat-form-field>
</form>